var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgService = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SERVICE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9909",
    "data-name": "Rechteck 9909",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_50",
    "data-name": "Pfad 50",
    d: "M10.449,41.909A4.256,4.256,0,0,1,8.085,41.2a4.411,4.411,0,0,1-.707-6.809L24.36,17.412A8.934,8.934,0,0,1,35.975,6.6l1.491.53-4.979,4.98a2.406,2.406,0,0,0,0,3.4,2.463,2.463,0,0,0,3.4,0l4.98-4.98.53,1.492A8.935,8.935,0,0,1,30.591,23.644L13.673,40.562A4.565,4.565,0,0,1,10.449,41.909ZM32.984,8.09a6.925,6.925,0,0,0-6.546,9.266l.212.595L8.792,35.808a2.412,2.412,0,0,0,.4,3.729,2.452,2.452,0,0,0,3.068-.389L30.052,21.355l.6.211a6.929,6.929,0,0,0,9.234-7.213L37.3,16.931A4.406,4.406,0,1,1,31.073,10.7l2.578-2.578C33.428,8.1,33.206,8.09,32.984,8.09Z",
    transform: "translate(0.912 0.908)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgService);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service.8b61526eda2e1560e10aefcafa6e62e1.svg";